import React from 'react';

import SkeletonTable from '../table/skeleton-table';

export function SkeletonContent() {
  return (
    <div className="p-6 h-content">
      <div className="flex" aria-label="Breadcrumb">
        <div className="h-6 w-6 rounded-full bg-skeleton-graphic animate-pulse" />
      </div>
      <div className="flex my-6">
        <div className="h-9 mt-1 w-28 rounded-full bg-skeleton-text animate-pulse" />
        <div className="mx-2 border border-ui-03" />
        <div className="h-9 mt-1 w-32 rounded-full bg-skeleton-text animate-pulse" />
      </div>
      <SkeletonTable />
    </div>
  );
}
